module.exports = __webpack_public_path__ + "static/media/introduce_p9@2x.a812d9a1.png";